import { jsonLdScriptProps } from "react-schemaorg";
import { BreadcrumbList } from "schema-dts";



export const StructuredDataBreadcrumb = ({ breadcrumbs, path }) => {
    return (
        <script
            {...jsonLdScriptProps<BreadcrumbList>({
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": breadcrumbs.map((item, index) => ({
                    "@type": "ListItem",
                    "position": index + 1,
                    "name": item.title,
                    "item": process.env.NEXT_PUBLIC_BASE_URL + (item.link ? item.link : path.startsWith("/") ? path : `/${path}`)
                }))
            })}
        />
    );
};